import { Core } from '@springtree/eva-services-core';
import buildAnonymousServiceState from '../../builders/build-anonymous-service-state.js';
import { getReactRecoilSettings } from '../../settings.js';
const listOrganizationUnitsState = buildAnonymousServiceState({
    allowEmptyRequest: true,
    key: 'organizationUnitList',
    service: Core.ListOrganizationUnitSummaries,
    beforeRequest: ({ req }) => {
        const settings = getReactRecoilSettings();
        const defaultRequest = {
            PageConfig: {
                Start: 0,
                Limit: settings.organizationUnitListLimit,
            },
        };
        const newRequest = {
            ...defaultRequest,
            ...req,
        };
        return newRequest;
    },
});
export default listOrganizationUnitsState;
//# sourceMappingURL=list-organization-units-state.js.map